export enum PolygonsPerformanceExtremes {
  IntensityTenBestPerforming = 1,
  IntensityTenWorstPerforming = 2,
  NEETenBestPerforming = 3,
  NEETenWorstPerforming = 4
}
